import React from 'react';
import { Link } from 'react-router-dom';
import PublicSiteHeader from '../../components/PublicSiteHeader/PublicSiteHeader';
import FooterLegalBar from '../../components/FooterLegalBar/FooterLegalBar';
import '../../components/PublicSiteHeader/publicSiteLayout.css';
import './LegalPages.css';

const LegalDocumentLayout = ({ title, lastUpdated, children }) => (
  <div className="legal-page">
    <PublicSiteHeader />
    <main className="legal-page-main public-page-below-site-header">
      <div className="legal-page-container">
        <nav className="legal-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>{title}</span>
        </nav>

        <header className="legal-page-header">
          <h1>{title}</h1>
          {lastUpdated ? <p className="legal-page-updated">Last updated: {lastUpdated}</p> : null}
        </header>

        <article className="legal-page-content">{children}</article>
      </div>
    </main>

    <footer className="legal-page-footer">
      <div className="legal-page-footer-inner">
        <FooterLegalBar variant="light" />
        <p className="legal-page-copyright">&copy; 2026 TenantScore. All rights reserved.</p>
      </div>
    </footer>
  </div>
);

export default LegalDocumentLayout;
